<template>
  <div class="merchant-create-wrapper">

    <!--表格查询表单-->
    <merchant-info-filter-form
      @filter="updateTableData"
      v-if="hasRes('merchant_info_index')" />

    <!--表格数据-->
    <custom-table
      :data="merchantList"
      @data-change="updateTableData"
      :fetch="false"
      v-if="hasRes('merchant_info_index')" >

      <el-table-column
        prop="merchant_id"
        label="商户入件 ID"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              扫呗 APPID: {{ scope.row.sb_app_id }}<br/>
              扫呗终端号: {{ scope.row.sb_term_id }}<br/>
              京东 APPID: {{ scope.row.jd_app_id }}<br/>
              邮箱: {{ scope.row.email }}<br/>
              手机: {{ scope.row.acct_mobile }}<br/>
              创建时间：{{ scope.row.create_at | dateformat }}<br/>
              更新时间：{{ scope.row.update_at | dateformat }}<br/>
            </div>
            <span>
              {{ scope.row.merchant_id }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="userid"
        label="商户名"
        align="center"
        header-align="center"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tooltip placement="top" v-if="scope.row.users.length > 0">
            <div slot="content">
              商户ID: {{ scope.row.users[0].userid }} <br/>
              商户昵称: {{ scope.row.users[0].alias || '未设置' }}
            </div>
            <span>
              {{ scope.row.users[0].username }}
            </span>
          </el-tooltip>
          <span v-else> 未绑定 </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="acct_name"
        label="收款人"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="acct_no_encry"
        label="收款账号"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="now_pay_channel"
        label="支付渠道"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <span @click="onPayInfoClick(scope.row)">{{ scope.row.now_pay_channel in payChannelEnum ? payChannelEnum[scope.row.now_pay_channel] : '未知'  }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="jd_review"
        label="京东审核状态"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag
            :type="reviewTagEnum[scope.row.jd_review] || 'warning'"
            size="mini">
            {{ reviewEnum[scope.row.jd_review] || '待完善' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="sb_review"
        label="扫呗审核状态"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag
            :type="reviewTagEnum[scope.row.sb_review] || 'warning'"
            size="mini">
            {{ reviewEnum[scope.row.sb_review] || '待完善' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="data_status"
        label="商户证件上传状态"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag
            :type="'data_status' in scope.row && scope.row.data_status === 0 ? 'danger': 'success'"
            size="mini">
            {{ 'data_status' in scope.row && scope.row.data_status === 0 ? '未提交': '已提交' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="complete_status"
        label="资料补全状态"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag
            :type="'complete_status' in scope.row && scope.row.complete_status === 0 ? 'danger': 'success'"
            size="mini">
            {{ 'complete_status' in scope.row && scope.row.complete_status === 0 ? '未补全': '已补全' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        width="300"
        fixed="right"
        label="操作"
        align="center"
        header-align="center"
        v-if="hasRes('merchant_info_supply') || hasRes('merchant_info_re_review')">

        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="onIdcardPreviewClick(scope.row)"
            :disabled="('complete_status' in scope.row && scope.row.complete_status === 1) || ('data_status' in scope.row && scope.row.data_status === 0)"
            v-if="hasRes('merchant_info_supply')">审核资料</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="onCompleteClick(scope.row)"
            :disabled="('complete_status' in scope.row && scope.row.complete_status === 1) || ('data_status' in scope.row && scope.row.data_status === 0)"
            v-if="hasRes('merchant_info_supply')">补全资料</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="onReReviewClick(scope.row)"
            :disabled="('jd_review' in scope.row && scope.row.jd_review !== 3) && ('sb_review' in scope.row && scope.row.sb_review !== 3)"
            v-if="hasRes('merchant_info_re_review')">复审资料</el-button>
        </template>
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="merchantCount"
      v-if="hasRes('merchant_info_index')"
      @page-change="updateTableData" />

    <dialog-merchant-info-supply
      :visible.sync="merchantInfoSupplyDialogVisible"
      :supplyingMerchant="supplyingMerchant"
      v-if="hasRes('merchant_info_supply')"
      @data-change="updateTableData" />

    <dialog-merchant-info-re-review
      :visible.sync="merchantInfoReReviewDialogVisisble"
      :reReviewingMerchant="reReviewingMerchant"
      v-if="hasRes('merchant_info_re_review')"
      @data-change="updateTableData" />

    <dialog-merchant-pay-info
      :visible.sync="merchantPayInfoDialogVisible"
      :updatingMerchant="updateingPayInfoMerchant"
      v-if="hasRes('merchant_info_update_pay')"
      @data-change="updateTableData" />

    <dialog-merchant-idcard-preview
      :visible.sync="merchantIdcardPreviewDialogVisible"
      :previewingMerchant="previewingMerchant"
      @data-change="updateTableData" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import MerchantInfoFilterForm from '@/components/bank/MerchantInfoFilterForm'
import DialogMerchantInfoSupply from '@/components/bank/DialogMerchantInfoSupply'
import DialogMerchantIdcardPreview from '@/components/bank/DialogMerchantIdcardPreview'
import DialogMerchantInfoReReview from '@/components/bank/DialogMerchantInfoReReview'
import DialogMerchantPayInfo from '@/components/bank/DialogMerchantPayInfo'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'MerchantInfoSupply',
  components: {
    CustomTable,
    CustomPaginate,
    MerchantInfoFilterForm,
    DialogMerchantInfoSupply,
    DialogMerchantInfoReReview,
    DialogMerchantIdcardPreview,
    DialogMerchantPayInfo
  },
  data () {
    return {
      reviewTagEnum: ['warning', 'primary', 'success', 'danger'],
      reviewEnum: ['待完善', '审核中', '审核通过', '审核不通过'],
      protocolTagEnum: ['info', 'primary', 'success', 'danger'],
      protocolEnum: ['未签署', '签署中', '签署成功', '签署失败'],
      payChannelEnum: {
        'unknown': '未知',
        'sb': '扫呗',
        'jd': '京东',
        'qm': '钱喵'
      },

      merchantInfoSupplyDialogVisible: false,
      supplyingMerchant: {},

      payInfoClickCount: 0,
      merchantPayInfoDialogVisible: false,
      updateingPayInfoMerchant: {},

      merchantIdcardPreviewDialogVisible: false,
      previewingMerchant: {},

      merchantInfoReReviewDialogVisisble: false,
      reReviewingMerchant: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters'
    ]),
    ...mapState('bank', [
      'merchantList',
      'merchantCount'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING,
      SET_FILTERS
    ]),
    ...mapActions('bank', [
      'getMerchants'
    ]),

    onIdcardPreviewClick (merchant) {
      if (merchant.id_card_z === 'not upload' && merchant.id_card_f === 'not upload') {
        this.$message({
          type: 'warning',
          message: '该商户未上传证件照片'
        })
        return
      }

      this.previewingMerchant = merchant
      this.merchantIdcardPreviewDialogVisible = true
    },
    onCompleteClick (merchant) {
      this.supplyingMerchant = merchant
      this.merchantInfoSupplyDialogVisible = true
    },
    onReReviewClick (merchant) {
      this.reReviewingMerchant = merchant
      this.merchantInfoReReviewDialogVisisble = true
    },
    onPayInfoClick (merchant) {
      if (!this.hasRes('merchant_info_update_pay')) return

      if (this.payInfoClickCount < 5) {
        this.payInfoClickCount++
      } else {
        this.updateingPayInfoMerchant = merchant
        this.merchantPayInfoDialogVisible = true
        this.payInfoClickCount = 0
      }
    },

    updateTableData () {
      if (!this.hasRes('merchant_info_index')) return

      this.setLoading(true)

      this.getMerchants({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        filters: this.filters
      }).then(res => {
        this.setLoading(false)
      }).catch(err => {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取商户入件信息列表失败'
        })
      })
    }
  },
  mounted () {
    if ('userid' in this.$route.query) {
      this.setFilters({
        userid: this.$route.query.userid
      })
    }
    this.updateTableData()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";

.merchant-create-wrapper {

  .dialog-upload-img {

    .upload-img-form {
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      align-items: center;
      text-align: center;

      .img-uploader {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409EFF;
        }
        .uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;
        }
        img {
          width: 178px;
          height: 178px;
          display: block;
        }
      }
    }

    .submit-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 18%;
      margin: 2rem auto 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/bank/MerchantInfoSupply.vue